// Shared flex-row class for a rank option, applied by the CALLER to its own element so a row needs no wrapper.
// `select-none` is a drag requirement, the counterpart of the row's `touch-action: none`: the whole row IS the
// handle, so without it a pointer-drag reads as a text-drag and paints a selection across the cards behind.
// It lives on the shared class rather than the sortable <li> so the overlay copy and the idle slots are covered too.
export const RANK_ROW_CLASS =
  'bg-card border-border flex items-center gap-3 rounded-xl border-2 px-3 py-2.5 text-sm leading-snug select-none'
